import { loadGooglePlacesApi } from "./load-api";
import { getGooglePlacesSessionToken } from "./session-token";

const CACHE: {
  autocompleteService?: google.maps.places.AutocompleteService;
} = {};

export async function googlePlacesAutocomplete({
  countries,
  input,
  sessionToken,
  useSessionToken,
  ...options
}: Omit<google.maps.places.AutocompletionRequest, "language"> & {
  countries?: string[];
  useSessionToken?: boolean;
}): Promise<google.maps.places.AutocompletePrediction[]> {
  if (!CACHE.autocompleteService) {
    await loadGooglePlacesApi();
    CACHE.autocompleteService = new google.maps.places.AutocompleteService();
  } else if (!input) {
    return [];
  }

  const request: google.maps.places.AutocompletionRequest = {
    componentRestrictions: { country: countries ?? null },
    input,
    region: "us",
    ...options,
    language: "en",
  };

  if (sessionToken) {
    request.sessionToken = sessionToken;
  } else if (useSessionToken) {
    request.sessionToken = getGooglePlacesSessionToken(true);
  }

  return (await CACHE.autocompleteService.getPlacePredictions(request))
    .predictions;
}
